import { css } from "styled-components";

export const ionGradientText = css`
  background: linear-gradient(
    90deg,
    #8A9BA6 0%,
    #ffffff 48%,
    #ffffff 60%,
    #8A9BA6 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
